/**
 * Custom icon list
 * All icons are loaded here for easy management
 *
 * 自定义图标加载表
 * 所有图标均从这里加载，方便管理
 */
import SvgMentionDown from '@/icons/svg/mention-down.svg?inline' // path to your '*.svg?inline' file.
import SvgNotFount from '@/icons/svg/not-fount.svg?inline' // path to your '*.svg?inline' file.
import SvgNote from '@/icons/svg/note.svg?inline' // path to your '*.svg?inline' file.
import SvgNoteBook from '@/icons/svg/note-book.svg?inline' // path to your '*.svg?inline' file.
import SvgNotData from '@/icons/svg/not-data.svg?inline' // path to your '*.svg?inline' file.
import SvgZhuangFa from '@/icons/svg/zhuangfa.svg?inline' // path to your '*.svg?inline' file.

export {
  SvgMentionDown,
  SvgNotFount,
  SvgNote,
  SvgNoteBook,
  SvgNotData,
  SvgZhuangFa,
}
